export const FETCHING_CUSTOMER_TRACKING = '@@toyota/FETCHING_CUSTOMER_TRACKING';
export const FETCHED_CUSTOMER_TRACKING = '@@toyota/FETCHED_CUSTOMER_TRACKING';
export const FETCHED_CUSTOMER_TRACKING_FAILED = '@@toyota/FETCHED_CUSTOMER_TRACKING_FAILED';

export const CLEAN_CUSTOMER_TRACKING_STATE = '@@toyota/CLEAN_CUSTOMER_TRACKING_STATE';

